module.exports = __webpack_public_path__ + "94bedfa2e52b1620c3383c0e874df704.fbx";